export const INPUT_TYPE_TEXT = "INPUT_TYPE_TEXT";
export const INPUT_TYPE_TEXTAREA= "INPUT_TYPE_TEXTAREA";
export const INPUT_TYPE_REQUIRED = "INPUT_TYPE_REQUIRED";
export const INPUT_TYPE_NUMERIC = "INPUT_TYPE_NUMERIC";
export const INPUT_TYPE_HIDDEN = "INPUT_TYPE_HIDDEN";
export const INPUT_TYPE_BOOLEAN = "INPUT_TYPE_BOOLEAN";
export const INPUT_TYPE_APPLIES_TO = "INPUT_TYPE_APPLIES_TO";
export const INPUT_TYPE_APPLIES_TO_DATA_TYPE = "INPUT_TYPE_APPLIES_TO_DATA_TYPE";
export const INPUT_TYPE_APPLIES_TO_TYPE = "INPUT_TYPE_APPLIES_TO_TYPE";
export const INPUT_TYPE_SELECT = "INPUT_TYPE_SELECT";
export const INPUT_TYPE_SELECT_WITH_CHANGE_FUNCTION = "INPUT_TYPE_SELECT_WITH_CHANGE_FUNCTION";
export const INPUT_TYPE_SELECTFROMDB = "INPUT_TYPE_SELECTFROMDB";
export const INPUT_TYPE_SELECTFROMDBCONCATENATION = "INPUT_TYPE_SELECTFROMDBCONCATENATION";
export const INPUT_TYPE_GET_FROM_PARAM = "INPUT_TYPE_GET_FROM_PARAM";
export const INPUT_TYPE_SELECT_GEOGRAPHY = "INPUT_TYPE_SELECT_GEOGRAPHY";
export const INPUT_TYPE_FILE = "INPUT_TYPE_FILE";
export const INPUT_TYPE_DATE = "INPUT_TYPE_DATE";
export const INPUT_TYPE_LOCATION = "INPUT_TYPE_LOCATION";
export const INPUT_TYPE_METRIC_GROUP = "INPUT_TYPE_METRIC_GROUP";
export const INPUT_TYPE_DISPLAY_PANEL_ITEMS = "INPUT_TYPE_DISPLAY_PANEL_ITEMS";

